// extracted by css-extract-rspack-plugin
export default {"taxonomyChoice":"taxonomyChoice-zh8EEU","disabledReason":"disabledReason-S95F6i"};